import React from "react";
import { Row, Col } from "react-bootstrap";

function Footer() {
  return (
    <div style={{}}>
      <Row style={{ backgroundColor: '#444444' }}>
        <Col className="text-center">
        </Col>
        <Col className="d-flex flex-row justify-content-center align-items-center text-center mb-4 mt-2">
          <h6 style={{ width: '150px', textAlign: 'center' }}>
            <a href="https://elafa.gr" style={{ color: 'inherit', textDecoration: 'none', marginRight: '20px' }}><strong>Αρχική</strong></a>
          </h6>
          <h6 style={{ width: '250px', textAlign: 'center' }}>
            <a href="https://elafa.gr/find-us/" style={{ color: 'inherit', textDecoration: 'none', marginRight: '20px' }}><strong>Που θα μας βρείτε</strong></a>
          </h6>
          <h6 style={{ width: '150px', textAlign: 'center' }}>
            <a href="https://elafa.gr/contact/" style={{ color: 'inherit', textDecoration: 'none' }}><strong>Επικοινωνία</strong></a>
          </h6>
        </Col>
        <Col className="text-center">
        </Col>

      </Row>
      <Row style={{ backgroundColor: '#444444' }}>
        <Col className="text-center">
          <p>&copy; {new Date().getFullYear()} elafa.gr | Created by <a href="https://sitelab.gr" style={{ color: 'inherit', textDecoration: 'none' }}>sitelab.gr</a></p>
        </Col>
      </Row>
    </div>
  );
}

export default Footer;
